export class TaxModel {
  taxId: number = 0;
  companyId: number = 0;
  taxTypeId: number = 0;
  code: string = "";
  alterCode: string = "";
  alterCode2: string = "";
  name: string = "";
  rate: number = 0;
  minimumBase: number = 0;
  saleAccount: string = "";
  saleDevolutionAccount: string = "";
  purchaseAccount: string = "";
  purchaseDevolutionAccount: string = "";
  departmentId: number = 0;
  cityId: number = 0;
  payAccountSelfWithholdingFuente: string = "";
  devolutionAccountSelfWithholdingFuente: string = "";
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}